<template>
  <div :class="['running-text-container', extraClasses]" :style="containerStyles">
    <!-- Simple text mode (Home.vue style) -->
    <div v-if="text && (!items || items.length === 0)" class="running-text simple-text" :style="textStyles">
      {{ text }}
    </div>

    <!-- Complex items mode (Promotion.vue style) -->
    <div v-else-if="items && items.length > 0" class="running-text-wrapper">
      <div class="running-text complex-text" :style="textStyles">
        <span v-for="n in repeat" :key="n">
          <span v-for="(item, itemIndex) in items" :key="`${n}-${itemIndex}`">
            {{ item }}
          </span>
        </span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'RunningText',
  props: {
    text: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    repeat: {
      type: Number,
      default: 10
    },
    speed: {
      type: Number,
      default: 20
    },
    gradient: {
      type: String,
      default: 'linear-gradient(45deg, #1a1a1a, #2a2a2a)'
    },
    textColor: {
      type: String,
      default: '#fff'
    },
    fontSize: {
      type: String,
      default: '16px'
    },
    extraClasses: {
      type: String,
      default: ''
    }
  },
  computed: {
    containerStyles () {
      return {
        background: this.gradient,
        animationDuration: `${this.speed}s`
      }
    },
    textStyles () {
      return {
        color: this.textColor,
        fontSize: this.fontSize,
        animationDuration: `${this.speed}s`
      }
    }
  }
}
</script>

<style scoped>
.running-text-container {
  overflow: hidden;
  position: relative;
}

/* Home.vue style (simple text) */
.running-text-container.home-style {
  position: fixed;
  top: 60px;
  left: 100px;
  right: 0;
  width: calc(100% - 100px);
  height: 42px;
  background: linear-gradient(45deg, #1a1a1a, #2a2a2a);
  border-bottom: 2px solid #DF4818;
  display: flex;
  align-items: center;
  z-index: 3;
}

.simple-text {
  white-space: nowrap;
  font-weight: bold;
  animation: marquee 10s linear infinite;
  display: inline-block;
  will-change: transform;
}

.simple-text:hover {
  animation-play-state: paused;
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

/* Promotion.vue style (complex text) */
.running-text-container.promotion-style {
  width: 100%;
  background: linear-gradient(90deg, #FFD700, #FFA500);
  padding: 10px 0;
}

.running-text-wrapper {
  overflow: hidden;
  white-space: nowrap;
}

.complex-text {
  display: inline-block;
  padding-left: 100%;
  animation: scroll-left 30s linear infinite;
  font-weight: bold;
  white-space: nowrap;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

/* Responsive */
@media (max-width: 991.98px) {
  .running-text-container.home-style {
    left: 0;
    width: 100%;
    z-index: 3;
  }
}

/* Interactive helpers */
.running-text-container.home-style:hover {
  background: linear-gradient(45deg, #2a2a2a, #3a3a3a) !important;
}

.simple-text,
.complex-text {
  /* Ensure text is visible */
  opacity: 1;
  visibility: visible;
}

/* Force visible text color */
.simple-text {
  color: #ffffff !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  font-size: 16px !important;
  padding: 0 10px;
  line-height: 40px;
}

.complex-text {
  color: #ffffff !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}
</style>
